export const LS_SURVEY_ALL = '@survey-questions';

export function saveAllQuestions(primaryQs, crossQs) {
  const all = [...primaryQs, ...crossQs];
  localStorage.setItem(LS_SURVEY_ALL, JSON.stringify(all));
}

export function loadAllQuestions() {
  try {
    const raw = localStorage.getItem(LS_SURVEY_ALL);
    if (!raw) return [];
    return JSON.parse(raw);
  } catch {
    return [];
  }
}